<template>
    <div>
      <div class="row">
        <div class="col-12">
          <page-header
            :page="page"
            @onReturn="() => $router.back()"
            :has-return="true"
          />
        </div>
      </div>
      <div class="search-bar">
        <validation-observer
            tag="form"
            ref="filterRef">
                <div class="row p-3">
                    <div class="col-md-3">
                        <validation-provider
                            mode="eager"
                            :rules="'required'"
                            v-slot="{ errors }"
                        >
                            <custom-drop-down
                                id="academicYear"
                                label="Año academico"
                                fieldkey="id"
                                fieldname="name"
                                placeholder="Seleccione"
                                :error="errors[0]"
                                custom-error-msg="Favor seleccionar un año académico."
                                :options="model.search.collections.academicYears"
                                v-model="model.search.filters.academicYear"
                                @input="onChangeAcademicYear"
                            />
                        </validation-provider>
                    </div>
                    <div class="col-md-3">
                        <validation-provider
                            mode="eager"
                            :rules="'required'"
                            v-slot="{ errors }"
                        >
                            <custom-drop-down
                                id="provider"
                                label="Proveedor"
                                fieldkey="id"
                                fieldname="name"
                                placeholder="Seleccione"
                                :error="errors[0]"
                                :disabled = "applyInitProviderRole()"
                                custom-error-msg="Favor seleccionar un proveedor."
                                :options="model.search.collections.providers"
                                v-model="model.search.filters.provider"
                                @input="onChangeProvider"
                            />
                        </validation-provider>
                    </div>
                    <div class="col-md-3">
                        <custom-drop-down
                            id="specialist"
                            label="Especialista"
                            fieldkey="id"
                            fieldname="name"
                            placeholder="Seleccione"
                            :options="model.search.collections.specialists"
                            v-model="model.search.filters.specialist"
                        />
                    </div>
                    <div class="col-md-3">
                        <br>
                        <action-button
                            @click="onHandlerSearch"
                            :i="'fa fa-sync'"
                            class="mt-2 mr-5 positionButton"
                            variant="success"
                        >
                            Procesar
                        </action-button>
                    </div>
                    <div class="col-md-3">
                        <label class="data-name mt-2">SIE</label>
                        <custom-input
                            type="text"
                            id="sie"
                            :mask-type="'SIE'"
                            v-model="model.search.filters.sie"
                            placeholder="Escriba número de SIE"
                        />
                    </div>
                    <div class="col-md-3">
                        <label class="data-name mt-2">Número de Solicitud</label>
                        <custom-input
                            type="text"
                            id="requestNumber"
                            v-model="model.search.filters.requesNumber"
                            placeholder="Número de Solicitud"
                            maxlength ="20"
                        />
                    </div>
                </div>
        </validation-observer>
        </div>

 
    </div>
  </template>
  
  <script>
  import PageHeader from 'PageHeader'
  import CustomInput from "@/components/common/form/CustomInput";
  import AcademicYearServices from '@/services/api/academicyear.api'
  import providerApi from '@/services/api/provider.api'
  import specialistApi from '@/services/api/specialist.api'
  import ReportServices from '@/modules/report/api'
  import DocumentServices from '@//modules/report/document'
  import ROLE from '@/utils/role'
  import ActionButton from "ActionButton";
  import CustomDropDown from 'custom-drop-down'
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  export default {
    components: {
      PageHeader,
      CustomInput,
      ActionButton,
      CustomDropDown,
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      page: {
        icon: 'fas fa-clipboard-list-check',
        title: 'Informe de Horas Compensatorias',
        routes: ['Informes', 'Informe de Horas Compensatorias'],
      },
      model: {
        search: {
          collections: {
            academicYears: [],
            providers: [],
            specialists: [],
          },
          filters: {
            academicYear: null,
            provider: null,
            specialist: null,
            sie: null,
            requesNumber: null
          },
        },
      },
    }),
    computed: {

    },
    async mounted() {
      this.applyInitProviderRole();
      await this.setFilters()
    },
    methods: {
      applyInitProviderRole() {
        const isProviderRole = this.userRole == ROLE.Provider;
        const hasOnlyOneCompany = this.userCompanies.length == 1;
        if (isProviderRole && hasOnlyOneCompany) {
          this.model.search.filters.provider = this.userCompanies[0];
          this.getSpecialist();
        }
  
        return isProviderRole && hasOnlyOneCompany;
      },
      async setFilters() {
        await AcademicYearServices.getExistingPeisAcademicYears().then(
          (res) => (this.model.search.collections.academicYears = res.data)
        );
      },
      async onChangeAcademicYear() {
        if (!this.applyInitProviderRole()) {
          this.model.search.filters.provider = null
        }
        this.model.search.collections.providers = []
        this.model.search.filters.billingCenter = null
        this.model.search.collections.billingCenters = []
        this.model.search.filters.specialist = null
        this.model.search.collections.specialists = []
  
        await this.getProvider()
      },
      async onChangeProvider() {
        this.model.search.filters.specialist = null
        this.model.search.collections.specialists = []
  
        await this.getSpecialist()
      },
      async getProvider() {
        if (this.applyInitProviderRole()) return;
  
        const res = await providerApi.getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        });
        
        const userCompanyIds = this.userCompanies.map(x => x.id);
        const availableCompanies = this.userRole == ROLE.Provider ?
        res.data.filter(x => userCompanyIds.includes(x.id))
        : res.data;
        this.model.search.collections.providers = availableCompanies;
  
        if (availableCompanies.length == 1) {
          this.model.search.filters.provider = availableCompanies[0]
          this.getSpecialist()
        }
      },
      async getSpecialist() {
        await specialistApi
          .getSpecialistProvider({
            academicYearId: this.model.search.filters.academicYear?.id,
            companyId: this.model.search.filters.provider?.id,
          })
          .then((res) => {
            this.model.search.collections.specialists = res.data;
  
            if (res.data.length == 1) {
              this.model.search.filters.specialist = res.data[0];
            }
          })
      },
      hasValue(paramValue) {
        return paramValue !== null && paramValue !== undefined
      },
      async onHandlerSearch() {
        this.process()
      },
      async process() {
        const isValid = await this.$refs.filterRef.validate()
  
        if (isValid) {
          await ReportServices.getReport('compensatoryhoursreport', {
            academicYearId: this.model.search.filters.academicYear?.id,
            providerId: this.model.search.filters.provider?.id,
            specialistId: this.model.search.filters.specialist?.id,
            studentSieId: this.model.search.filters.sie,
            requestNumber: this.model.search.filters.requesNumber,
          }).then((res) => DocumentServices.Download(res.data))
        }
      },
    },
  }
  </script>
  <style lang="scss" scoped>
    .search-bar {
        background: #f4f6f3 0% 0% no-repeat padding-box;
        border-radius: 5px;
    }
    .positionButton{
        position: relative;
        left: 150px;
    }
  </style>
  